export default __webpack_public_path__ + "static/media/team-icon.4ab9d290.svg";